export var DEBT_TYPES = {
  CREDIT_CARD: 'credit_card',
  PERSONAL_LOAN: 'personal_loan',
  AUTO_LOAN: 'auto_loan',
  STUDENT_LOAN: 'student_loan'
};
export var DEBT_TYPE_PRIORITY_ORDER = [DEBT_TYPES.CREDIT_CARD, DEBT_TYPES.PERSONAL_LOAN, DEBT_TYPES.AUTO_LOAN, DEBT_TYPES.STUDENT_LOAN];
export var DEBT_ACTIVATION_STATES = {
  UNKNOWN: 'Unknown',
  UNACTIVATED: 'Unactivated',
  ACTIVATED: 'Activated',
  BLOCKED_TU: 'BlockedTU',
  BLOCKED_DTI: 'BlockedDTI',
  BLOCKED_NO_DEBT_TRADELINES: 'BlockedNoDebtTradelines'
};
export var DTI_THRESHOLD = 0.4;